import React, { useEffect, useRef, useState } from "react";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import {
  AxiosRequest,
  createCokies,
  getOptionsForUser,
  getURLparam,
  hasURLparam,
  updateOptionsForUser,
} from "../../../Url";
import { ImgURL } from "../../../Url";
import { Box, Skeleton, Stack } from "@mui/material";
import { IconButton, ListItem, Typography } from "@mui/material";
import SideBarButton from "./SideBarButton";
import { createRoot, Root } from "react-dom/client";
import {
  getDocInfo,
  getIconsAsync,
  getSectionByID,
  HiddenNavSet,
  isEmptyObject,
  openDocumentInModal,
} from "../../Tools/Tools";
import cn from "classnames";
import SectionSearch from "./SectionSearch";
import setHost from "../../../SetHost";
import { renderMessageBox } from "../../../TokenProcessing/TokenProcessing";
import { useAtom, useAtomValue, useSetAtom } from "jotai";
import {
  animationsAtom,
  currentTheme,
  sectionListAtom,
  selectedSectionAtom,
  setSelectedSectionAtom,
} from "../../../../atoms";
import { hasStartPageAtom } from "../../../../atoms";

export default function SideBar(props: any) {
  const setSelectedSection = useSetAtom(setSelectedSectionAtom);
  const [sectionList, setSectionList] = useAtom(sectionListAtom);
  const theme = useAtomValue(currentTheme);
  const setHasStartPageAtom = useSetAtom(hasStartPageAtom);
  const [open, setOpen] = useState(false);
  const [selectSearch, setSelectSearch] = useState<any>(undefined);
  const [data2, setData2] = useState(new Map());
  const [firstLoad, setFirstLoad] = useState(true);
  const animationsOn = useAtomValue(animationsAtom);
  const bgcolorthemeSelect = theme === "light" ? "#dcd8cc" : "#3d5b75";
  const bgcolortheme = theme === "light" ? "#faf9f5" : "#628cb6";
  const sideBarSelected = useAtomValue(selectedSectionAtom);
  const searchBlockRoot = useRef<Root>();
  const host = setHost();

  useEffect(() => {
    getSectionList();
  }, []);

  useEffect(() => {
    if (props.SearhJson !== undefined && props.SearhJson !== null) {
      setSelectSearch(props.SearhJson);
    }
  }, [props.SearhJson]);

  useEffect(() => {
    if (selectSearch !== undefined && selectSearch !== null) {
      let srhjson: any = {};
      if (selectSearch.from === "notif") {
        Object.assign(srhjson, {
          Name: GetElementAttributeByID(props.SearhJson.ID, sectionList, "Name"),
          CLSID: GetElementAttributeByID(props.SearhJson.ID, sectionList, "CLSID"),
          ID: props.SearhJson.ID,
          Who: props.SearhJson.Who,
        });
      } else {
        srhjson = selectSearch;
      }
      switch (srhjson.Who) {
        case "Section":
          HiddenNavSetSection({
            id: srhjson.ID,
            title: srhjson.Name,
            CLSID: srhjson.CLSID,
            Patch: srhjson.Name,
            img: `${host}/server~${GetElementAttributeByID(srhjson.ID, sectionList, "Image")}`,
          });
          updateSelected({
            id: srhjson.ID,
            title: srhjson.Name,
            Patch: srhjson.Name,
            CLSID: srhjson.CLSID,
          });
          UpdCollapsed(srhjson.ID);
          break;
        case "Report":
          // (selectSearch)
          delete srhjson.CLSID;
          delete srhjson.Path;
          delete srhjson.ProgID;
          HiddenNavSetSection({
            id: srhjson.Section.ID,
            title: srhjson.Section.Name,
            CLSID: srhjson.Section.CLSID,
            Patch: srhjson.Section.Name,
            img: `${host}/server~${GetElementAttributeByID(srhjson.Section.ID, sectionList, "Image")}`,
          });
          UpdCollapsed(srhjson.Section.ID);
          updateSelected(
            {
              id: srhjson.Section.ID,
              title: srhjson.Section.Name,
              Patch: srhjson.Section.Name,
              CLSID: srhjson.Section.CLSID,
            },
            {
              Selected: { ID: srhjson.ID, Name: srhjson.Name },
              Who: srhjson.Who,
            },
          );
          break;
        case "Documents":
          // (selectSearch)
          delete srhjson.CLSID;
          delete srhjson.Path;
          delete srhjson.ID;
          delete srhjson.ProgID;
          HiddenNavSetSection({
            id: srhjson.Section.ID,
            title: srhjson.Section.Name,
            CLSID: srhjson.Section.CLSID,
            Patch: srhjson.Section.Name,
            img: `${host}/server~${GetElementAttributeByID(srhjson.Section.ID, sectionList, "Image")}`,
          });
          UpdCollapsed(srhjson.Section.ID);
          setSelectedSection({
            ID: srhjson.Section.ID,
            CLSID: srhjson.Section.CLSID,
            Name: srhjson.Section.Name,
            Who: srhjson.Who,
            Documents: srhjson.Section.Documents,
            Selected: {
              DocCfgID: srhjson.DocCfgID,
              docid: srhjson.docid,
              modal: srhjson.modal,
              card: srhjson.card,
            },
          });
          // updateSelected(
          //   {
          //     id: srhjson.Section.ID,
          //     title: srhjson.Section.Name,
          //     Patch: srhjson.Section.Name,
          //     CLSID: srhjson.Section.CLSID,
          //     Documents:srhjson.Section.Documents,
          //   },
          //   {
          //     Selected: {
          //       DocCfgID: srhjson.DocCfgID,
          //       docid: srhjson.docid,
          //       modal: srhjson.modal,
          //       card: srhjson.card,
          //     },
          //     Who: srhjson.Who,
          //   }
          // );
          break;
        case "Pages":
          break;
      }
    }
  }, [selectSearch]);

  async function parsedUrl(sideBarData: any) {
    if (hasURLparam("parsed") && sideBarData !== undefined) {
      const secid = getURLparam("secid");
      const jsondata: any = getSectionByID(secid);
      let dataAboutSelectedDoc: any = {
        Section: {
          CLSID: jsondata.CLSID,
          ID: jsondata.ID,
          Name: jsondata.Name,
          Documents: jsondata.Documents,
        },
      };
      if (hasURLparam("docid")) {
        const docId = getURLparam("docid");
        const docInfo = await getDocInfo(docId);
        const docInfoSections = docInfo.Sections?.split(",");
        const docCfgId = getURLparam("doccfgid");
        // const secId = getURLparam("secid");
        const card = hasURLparam("card");
        const modal = hasURLparam("modal");
        if (!dataAboutSelectedDoc.Section.ID && docInfoSections && docInfoSections.length > 0) {
          //находим и получаем данные из нашего списка секций
          for (const value of docInfoSections) {
            if (!dataAboutSelectedDoc.Section.ID) {
              const sectionInfo = getSectionByID(value);
              dataAboutSelectedDoc = { ...dataAboutSelectedDoc, Section: sectionInfo };
            }
          }
        }
        dataAboutSelectedDoc = {
          ...dataAboutSelectedDoc,
          docid: docId,
          DocCfgID: docCfgId || docInfo.DocCfgID,
          card,
          modal,
          Who: "Documents",
        };
        if (docInfo.Result === "1" && dataAboutSelectedDoc.DocCfgID) {
          window.history.replaceState(
            { additionalInformation: "Переход" },
            "UrlSearch",
            window.location.href.split("?")[0],
          );
          if (dataAboutSelectedDoc.Section.ID) {
            setSelectSearch(dataAboutSelectedDoc);
            return true;
          } else if (modal) {
            openDocumentInModal(dataAboutSelectedDoc.DocCfgID, docId);
          }
        } else {
          renderMessageBox({ dlgType: 1, buttons: 1, message: "Документ не найден" });
        }
        return false;
      }
      // props.setSelected(newValue);
    }
    return false;
  }

  function UpdCollapsed(ID: string) {
    let valueany: any,
      keyS = 0,
      currentDeep,
      DeepArr = [];
    for (const [key, value] of Object.entries(sectionList)) {
      valueany = value;
      keyS += 1;
      currentDeep = valueany.Deep === undefined ? 0 : Number(valueany.Deep);
      if (currentDeep === 0) {
        DeepArr = [];
      }
      if (sectionList[keyS] !== undefined && Number(sectionList[keyS]["Deep"]) > currentDeep) {
        DeepArr.push(valueany.ID);
      }
      if (ID === valueany.ID) {
        for (const [key, value] of Object.entries(DeepArr)) {
          data2.set(value, true);
        }
      }
    }
  }

  const handleClick = (event: any) => {
    setOpen(!open);
    let ID = event.currentTarget.getAttribute("id");
    setData2(data2.set(ID, !data2.get(event.currentTarget.getAttribute("id"))));
  };

  const updateSelected = (event: any, data?: any) => {
    let ID,
      CLSID,
      Name,
      Patch,
      img: any,
      dataSectionList = data ? (data.Who ? sectionList : data) : sectionList;
    if (event && event.currentTarget && event.currentTarget === window) {
      window.location.reload();
      return;
    }
    if (event.title) {
      ID = event.id;
      CLSID = event.CLSID;
      Name = event.title;
      Patch = event.Patch;
    } else if (!event.state) {
      let el = event.currentTarget;
      if (!el) el = event.target.parentNode;
      ID = el.getAttribute("id");

      CLSID = GetElementAttributeByID(ID, dataSectionList, "CLSID");
      Name = el["innerText"];
      Patch = el["title"] ? el["title"] + "/" + Name : Name;
      img = el.querySelector("img");
      if (img) img = img.src;
      else img = "";
    } else {
      ID = event.state.id;
      CLSID = event.state.CLSID;
      if (event.state.title) Name = event.state.title;
      else {
        Name = event.state.name;
      }
    }
    if (data && data.Who) {
      setSelectedSection({
        ID: ID,
        CLSID: CLSID,
        Name: Name,
        Who: data.Who,
        Selected: data.Selected,
      });
    } else {
      setSelectedSection(getSectionByID(ID));
    }
    let dataState = {
      id: ID,
      title: Name,
      CLSID: CLSID,
      Patch: Patch,
      img: img,
    };
    HiddenNavSetSection(dataState);
    updateOptionsForUser({
      ID: ID,
      CLSID: CLSID,
      Name: Name,
    });
    // let NameSection = document.getElementById("NameSection");
    // NameSection
    //   ? (NameSection.innerText = Name)
    //   : (NameSection = document.createElement("div"));
  };

  function HiddenNavSetSection(dataState: any) {
    HiddenNavSet(dataState);
  }

  function EmptyCLSIDSectionData(ID: string, dataLocal: any) {
    let DeepParent: any,
      DeepChild: any,
      bool = true,
      valanya: any,
      jsonEmptyCLSID = [];
    if (ID !== undefined) {
      for (const value of Object.values(dataLocal)) {
        valanya = value;
        if (DeepParent === undefined) {
          if (valanya.ID === ID) {
            DeepParent = valanya.Deep === undefined ? 0 : Number(valanya.Deep);
            DeepChild = DeepParent + 1;
          }
        } else {
          if (Number(valanya.Deep) === DeepChild && bool) {
            jsonEmptyCLSID.push(valanya);
          } else {
            bool = false;
          }
        }
      }
    }
    return jsonEmptyCLSID;
  }

  const getSectionList = async () => {
    let params = new Map();
    // ,json: any;
    params.set("comand", "GetSectionList");
    params.set("Simple", "1");
    params.set("full", "1");
    params.set(`png`, `1`);
    let json: any = await AxiosRequest(true, params);
    await getIconsAsync(85);
    // AxiosRequest(true, params).then((json) => {
    if (isEmptyObject(json) || json === undefined || json === null) {
      createCokies("LicG", "");
      if (getOptionsForUser()?.from) {
        window.location.href = getOptionsForUser()?.from.replaceAll("@", "/");
      } else {
        // let navigateUrl= ""
        // if (hasURLparam("parsed")) {
        //   navigateUrl += getUrlSearh();
        // }
        // navigate(navigateUrl);
      }
    } else {
      // json["Sections"].push({
      //   CLSID: "{D22DFDA0-DB27-4FB4-865F-B478DB85F2A4}",
      //   ID: "-2",
      //   Name: "Фоновые процессы",
      //   // Hidden: true,
      // });
      setSectionList(json["Sections"]);
      setHasStartPageAtom(json.HasStartPage === "1");
      ListItems(json["Sections"]);
      if (await parsedUrl(json["Sections"])) return;
      let jsonEmptyCLSID: any,
        PageID = json.PageID;
      let selectedJson = getOptionsForUser();
      if (selectedJson?.CLSID === undefined) jsonEmptyCLSID = EmptyCLSIDSectionData(selectedJson?.ID, json["Sections"]);
      if (selectedJson?.ID === undefined) {
        const clsid = GetElementAttributeByID(PageID, json["Sections"], "CLSID");
        const name = GetElementAttributeByID(PageID, json["Sections"], "Name");
        const title = GetElementAttributeByID(PageID, json["Sections"], "Title");
        const finaleSectionName = title === undefined || title === "" ? name : title;

        UpdCollapsed(PageID);
        try {
          updateSelected(
            {
              id: PageID,
              title: finaleSectionName,
              Patch: name,
              CLSID: clsid,
            },
            json["Sections"],
          );
          HiddenNavSetSection({
            id: PageID,
            title: finaleSectionName,
            CLSID: clsid,
            Patch: name,
            img: `${host}/server~${GetElementAttributeByID(PageID, sectionList, "Image")}`,
          });
        } catch (error) {
          console.error(error);
        }
      } else {
        let dataForDispath;
        if (selectedJson?.ID < 0) dataForDispath = selectedJson;
        else dataForDispath = getSectionByID(selectedJson?.ID);
        let docState: any = localStorage.getItem("docState");
        docState = JSON.parse(docState);
        if (docState && docState.activerecord && selectedJson?.Selected && selectedJson?.Selected.docid) {
          dataForDispath = {
            ...dataForDispath,
            Selected: selectedJson?.Selected,
          };
        }
        setSelectedSection(dataForDispath);
        HiddenNavSetSection({
          id: dataForDispath.ID,
          title: dataForDispath.Name,
          CLSID: dataForDispath.CLSID,
          Patch: dataForDispath.Name,
          img: `${host}/server~${dataForDispath.Image}`,
        });
        props.setSelected({
          // id: selectedJson?.ID,
          // clsic: selectedJson?.CLSID,
          // name: selectedJson?.Name,
          jsonEmptyCLSID: jsonEmptyCLSID,
        });
      }
    }
    // });
    // json = XMLrequest(params);
  };

  function ListItems(List: any) {
    if (List !== undefined && List.length > 0) {
      let ID,
        keyS = 0;
      for (const [key, value] of Object.entries(List)) {
        keyS += 1;
        ID = List[key]["ID"];
        if (List[key]["Deep"] == null) {
          setData2(data2.set(ID, CountSections(List)));
        }
        if (List[keyS] !== undefined && List[keyS]["Deep"] > List[key]["Deep"]) {
          setData2(data2.set(ID, false));
        }
      }
    }
  }

  function CountSections(List: any) {
    let ID,
      keyS = 0;
    for (const [key, value] of Object.entries(List)) {
      if (List[key]["Deep"] == null) {
        keyS += 1;
      }
      if (keyS > 1) return false;
    }
    if (keyS === 1) return true;
  }

  function GetElementAttributeByID(CurrnetID: string, List: any, Attribute: string) {
    let backvalue;
    List.filter((Elements: any) => {
      if (Elements["ID"] == CurrnetID) return (backvalue = Elements[Attribute]);
    });
    return backvalue;
  }

  function MenuList(SectionList: any) {
    // фцнкция отрисовки меню
    if (SectionList !== undefined && SectionList.length > 0) {
      let Name,
        ID,
        currentDeep,
        openSet,
        openSetDeep,
        mainCollapse,
        deepCollapse,
        Img,
        keyS = 0,
        howDeep = 4,
        mainCollapseID,
        openSetID,
        deepCollapseID,
        leftP,
        hidden;
      let assemblyLists = []; //сюда записываем все секции а потом отправляем на отрисовку

      for (const [key, value] of Object.entries(SectionList)) {
        //ходим по всему объекту
        Name = SectionList[key]["Title"] === undefined ? SectionList[key]["Name"] : SectionList[key]["Title"];
        ID = SectionList[key]["ID"];
        currentDeep = SectionList[key]["Deep"];
        Img = ImgURL(SectionList[key]["Image"], {
          height: "32px",
          width: "32px",
        });
        hidden = SectionList[key]["Hidden"] === undefined ? false : SectionList[key]["Hidden"] === true ? true : false;
        //Img = ImgBASE64(SectionList[key]["RCDATA"]);
        keyS += 1;
        if (currentDeep == null) {
          //если нет DEEP то отрисовываем родителя
          mainCollapse = data2.get(ID);
          mainCollapseID = ID;
          openSet = data2.get(ID);
          openSetID = ID;
          assemblyLists.push(
            <ListItem
              component="div"
              id={ID}
              disablePadding
              key={ID}
              style={{
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: 0,
                paddingRight: 0,
                display: hidden ? "none" : "inherit",
              }}
              sx={{
                "& .Mui-selected": { backgroundColor: "rgb(35, 114, 191)" },
                "& .MuiListItemSecondaryAction-root": {
                  right: "auto",
                  left: "0%",
                },
              }}
              selected={sideBarSelected.ID === ID}
              secondaryAction={
                SectionList[keyS] !== undefined && SectionList[keyS]["Deep"] >= 1 ? (
                  <IconButton id={ID} onClick={handleClick} style={{ width: 25, height: 25 }}>
                    {SectionList[keyS] !== undefined && SectionList[keyS]["Deep"] >= 1 ? (
                      openSet ? (
                        <ExpandLess fontSize="small" />
                      ) : (
                        <ExpandMore fontSize="small" />
                      )
                    ) : (
                      <></>
                    )}
                  </IconButton>
                ) : null
              }
            >
              <ListItemButton
                style={{ paddingRight: 0, color: "white" }}
                key={ID}
                component="div"
                id={ID}
                onClick={updateSelected}
              >
                <ListItemIcon
                  style={{
                    minWidth: "0px",
                    paddingRight: "10px",
                    paddingLeft: 10,
                    display: SectionList[key]["Image"] === undefined ? "none" : "grid",
                  }}
                >
                  {SectionList[key]["Image"] ? Img : ""}
                </ListItemIcon>
                <ListItemText
                  className={cn("fontColorStimate", {
                    light: theme === "light",
                  })}
                  primary={
                    <Typography
                      variant="body1"
                      style={{
                        fontSize: "0.875rem",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        width: "99.9%",
                      }}
                      title={Name}
                    >
                      {Name}
                    </Typography>
                  }
                />
              </ListItemButton>
            </ListItem>,
          );
        } else if (currentDeep !== null) {
          if (ID === sideBarSelected.ID && firstLoad === true) {
            data2.set(mainCollapseID, true);
            if (currentDeep === "2" || currentDeep === "3") {
              data2.set(openSetID, true);
              if (currentDeep === "3") {
                data2.set(deepCollapseID, true);
              }
            }
            setFirstLoad(false);
          }
          //если есть DEEP
          howDeep = 4;
          if (SectionList[key]["Image"] !== undefined) {
            switch (
              currentDeep //Определяем сколько сдвинуть направо отностиельно родителя
            ) {
              case "1":
                openSet = mainCollapse;
                howDeep += 2;
                leftP = 19;
                break;
              case "2":
                howDeep += 4;
                leftP = "36px";
                break;
              case "3":
                howDeep += 6;
                break;
            }
          }

          if (SectionList[keyS] !== undefined && SectionList[keyS]["Deep"] > currentDeep) {
            //если ключ НЕ необъявен и след deep больше текущего, то рисуем родителя
            currentDeep == "2" ? (deepCollapse = openSet) : (deepCollapse = undefined);
            currentDeep == "2" ? (deepCollapseID = openSetID) : (deepCollapseID = "0");
            openSetDeep = openSet;
            assemblyLists.push(
              <Collapse key={ID} in={openSet && mainCollapse} timeout={animationsOn ? "auto" : 0} unmountOnExit>
                {(openSet = data2.get(ID)) ? "" : ""}
                <ListItem
                  component="div"
                  key={ID}
                  style={{
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: 0,
                    paddingRight: 0,
                    display: "inherit",
                  }}
                  sx={{
                    "& .MuiListItemSecondaryAction-root": {
                      right: "auto",
                      left: leftP,
                    },
                  }}
                  secondaryAction={
                    <IconButton id={ID} onClick={handleClick} style={{ width: 25, height: 25 }}>
                      {openSet ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
                    </IconButton>
                  }
                >
                  <ListItemButton
                    style={{ paddingRight: 0, color: "white" }}
                    key={ID}
                    component="div"
                    sx={{
                      pl: SectionList[key]["Image"] ? howDeep : "",
                      "& .Mui-selected": {
                        backgroundColor: "rgb(35, 114, 191)",
                      },
                    }}
                    id={ID}
                    selected={sideBarSelected.ID === ID}
                    onClick={updateSelected}
                  >
                    <ListItemIcon>{SectionList[key]["Image"] ? Img : ""}</ListItemIcon>
                    <ListItemText
                      className={cn("fontColorStimate", {
                        light: theme === "light",
                      })}
                      primary={
                        <Typography
                          noWrap
                          variant="body1"
                          style={{
                            fontSize: "0.875rem",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            width: "99.9%",
                          }}
                          title={Name}
                        >
                          {Name}
                        </Typography>
                      }
                    />
                  </ListItemButton>
                </ListItem>
              </Collapse>,
            );
            openSetID = ID;
          } else {
            assemblyLists.push(
              <Collapse
                key={ID}
                in={openSet && mainCollapse && currentDeep == "3" ? deepCollapse : openSet && mainCollapse}
                timeout={animationsOn ? "auto" : 0}
                unmountOnExit
              >
                <ListItemButton
                  style={{ color: "white" }}
                  key={ID}
                  component="div"
                  sx={{
                    pl: SectionList[key]["Image"] ? howDeep : "",
                    "& .Mui-selected": {
                      backgroundColor: "rgb(35, 114, 191)",
                    },
                  }}
                  selected={sideBarSelected.ID === ID}
                  id={ID}
                  onClick={updateSelected}
                >
                  <ListItemIcon>{SectionList[key]["Image"] ? Img : ""}</ListItemIcon>
                  <ListItemText
                    className={cn("fontColorStimate", {
                      light: theme === "light",
                    })}
                    primary={
                      <Typography
                        variant="body1"
                        style={{
                          fontSize: "0.875rem",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          width: "99.9%",
                        }}
                        title={Name}
                      >
                        {Name}
                      </Typography>
                    }
                  />
                </ListItemButton>
              </Collapse>,
            );
          }
        }
      }
      setTimeout(() => {
        const SearchBlock = document.getElementById("SearchBlock");
        if (SearchBlock) {
          if (!searchBlockRoot.current) searchBlockRoot.current = createRoot(SearchBlock);
          searchBlockRoot.current.render(<SectionSearch data={sectionList} setSelected={setSelectSearch} />);
        }
      }, 500);

      return assemblyLists;
    } else {
      return (
        <Stack spacing={0.5}>
          {["1", "2", "3", "4", "5", "6", "7", "8", "90", "91", "92", "95"].map((item, index) => {
            return (
              <Skeleton
                key={`skeleton_${item}_${index}`}
                animation="wave"
                variant="rectangular"
                width={"100%"}
                height={48}
              />
            );
          })}
        </Stack>
      );
    }
  }
  window.onpopstate = updateSelected;

  return (
    <Box style={{ scrollbarWidth: "none" }} sx={{ overflow: "auto" }}>
      <List
        component="div"
        disablePadding
        sx={{
          "&& .Mui-selected, && .Mui-selected:hover": {
            backgroundColor: bgcolorthemeSelect,
          },
        }}
      >
        {MenuList(sectionList)}
      </List>
    </Box>
  );
}
